import React from 'react';
import IconButton from '../../buttons/IconButton';
import { useNavigate } from 'react-router-dom';
import { useFormikContext } from 'formik';
import { FORMS } from '../../../schemas/stepMap';

export default function SubmitButtons({
  isSubmitting,
  isValid,
  errors,
  submitForm,
  type = 'submit',
  setValues,
  embedVersion,
  next,
  label = 'Submit Form',
  description = '',
}) {
  const { values } = useFormikContext();
  const navigate = useNavigate();

  const handleSubmitForm = async () => {
    if (Object.keys(errors || {}).length > 0) {
      const fieldName = Object.keys(errors)[0];
      const field = document.querySelector(`[name="${fieldName}"]`);

      if (!field) return;
      field.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }

    try {
      await submitForm();
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  //this function is used to submit the form and navigate to the next page, and sets a variable so that the next page knows that the form has been submitted
  const onOptionButton = async (path, submittedField) => {
    let newValues = { ...values };

    if (submittedField) {
      newValues = { ...newValues, [submittedField]: true };
    }

    setValues({
      ...newValues,
    });

    let submitted;
    try {
      submitted = await handleSubmitForm();
    } catch (error) {
      console.error(error);
    } finally {
      path && submitted && navigate(path);
    }
  };

  const buttonActions = {
    submit: () => {
      handleSubmitForm();
    },

    purchaseWorksheet: () =>
      onOptionButton(
        embedVersion ? null : `../${FORMS.purchaseAnalysis.pathName}`,
        'purchaseWorksheetSubmitted'
      ),
    flipWorksheet: () =>
      onOptionButton(
        `../${FORMS.flipAnalysis.pathName}`,
        'flipWorksheetSubmitted'
      ),
    rehabWorksheet: () =>
      onOptionButton(
        `../${FORMS.BuyAndHoldAnalysis.pathName}`,
        'rehabWorksheetSubmitted'
      ),
    refinancing: () =>
      onOptionButton(
        '../summary/brrrr-analysis',
        'refinancingWorksheetSubmitted'
      ),
  };

  return (
    <div className="flex items-center z-20 px-5 py-4 rounded-lg bg-white justify-between gap-4 h-[82px]">
      <div className="flex flex-col gap-1">
        <h3 className="text-lg font-medium font-serif text-neutral-900">
          {label}
        </h3>
        <p className="text-md hidden md:block font-normal text-neutral-500">
          {description}
        </p>
      </div>

      <IconButton
        text="Submit"
        style="primary-lg"
        srText={'Submit Form'}
        handleClick={() => buttonActions[type]()}
        disabled={isSubmitting || !isValid}
      />
    </div>
  );
}
